import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { ContractStatusFilter, ContractsListFilterKeys } from '../../model/types';

interface ContractStatusSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const ContractStatusSelect: FC<ContractStatusSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('contracts');

  const contractStatusOptions = useMemo<Array<{ label: string; value: ContractStatusFilter }>>(() => {
    return [
      { label: t('Active'), value: ContractStatusFilter.ACTIVE },
      { label: t('Closed'), value: ContractStatusFilter.CLOSED },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(ContractsListFilterKeys.isActive);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Status')}
      placeholder={t('All')}
      bordered
      allowClear
      options={contractStatusOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
